import { CellStyle, TaskFormatting } from '../api/types';
import { CSSProperties } from 'react';

/** Fusionne le style de ligne et le style de cellule — la cellule gagne propriété par propriété. */
export function mergeCellStyle(formatting: TaskFormatting | null | undefined, column: string): CellStyle {
  return { ...formatting?.row, ...formatting?.cells?.[column] };
}

/** Convertit un CellStyle en style inline React — "surligné" est rendu comme un trait sous le texte, distinct du fond plein. */
export function cellStyleToCss(style: CellStyle): CSSProperties {
  const css: CSSProperties = {};
  if (style.fontFamily) css.fontFamily = style.fontFamily;
  if (style.fontSize) css.fontSize = style.fontSize;
  if (style.color) css.color = style.color;
  if (style.backgroundColor) css.backgroundColor = style.backgroundColor;
  if (style.bold) css.fontWeight = 700;
  if (style.italic) css.fontStyle = 'italic';
  const decorations: string[] = [];
  if (style.underline) decorations.push('underline');
  if (style.strikethrough) decorations.push('line-through');
  if (decorations.length) css.textDecoration = decorations.join(' ');
  if (style.highlightColor) css.boxShadow = `inset 0 -0.45em 0 0 ${style.highlightColor}`;
  return css;
}

export function isEmptyStyle(style: CellStyle): boolean {
  return Object.values(style).every((v) => v === undefined || v === false);
}
